import { API_ENDPOINT } from 'constants/configs';
import { getClientConfig } from 'constants/clients';
import { post } from 'services/api';
import {
  getLatestPreparedCartSnapshot,
  getPendingCartSnapshots,
  markCartSnapshotSynced,
} from 'helpers/cartSnapshotOutbox';
import { getCartStoreKey } from 'helpers/cartScope';

const activeSyncs = {};

export const syncPendingCartSnapshots = async () => {
  const storeKey = getCartStoreKey();
  if (activeSyncs[storeKey]) return activeSyncs[storeKey];

  const sync = (async () => {
    for (let pass = 0; pass < 10; pass += 1) {
      const pending = await getPendingCartSnapshots(storeKey);
      if (!pending.length) return;

      for (const snapshot of pending) {
        await post('auth/cart-snapshot', {
          cart_token: snapshot.cartToken,
          revision: snapshot.revision,
          items: snapshot.items,
          customer_email: snapshot.customerEmail,
        });
        await markCartSnapshotSynced(snapshot.key, snapshot.revision);
      }
    }
  })();

  activeSyncs[storeKey] = sync;
  try {
    await sync;
  } finally {
    delete activeSyncs[storeKey];
  }
};

export const sendPreparedCartSnapshotsOnPageHide = () => {
  if (typeof window === 'undefined' || typeof fetch !== 'function') return;
  const clientToken = getClientConfig()?.clientToken;
  if (!clientToken || !API_ENDPOINT) return;

  const endpoint = `${String(API_ENDPOINT).replace(/\/+$/, '')}/auth/cart-snapshot`;
  getLatestPreparedCartSnapshot().forEach((snapshot) => {
    const body = JSON.stringify({
      cart_token: snapshot.cartToken,
      revision: snapshot.revision,
      items: snapshot.items,
      customer_email: snapshot.customerEmail,
      client_token: clientToken,
      origin: window.location.origin,
    });
    if (body.length > 60000) return;

    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    }).catch(() => {});
  });
};
